import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import { RateInterface } from '../../store/callrecorder/ratesSlice';

const PREFIX = 'callrecorder';

const processStrategy = (entity: any) => ({
  ...entity,
  url: `/callrecorder/rates/${entity.id}`
});

export const ratesEntity = new schema.Entity('rates', {}, { processStrategy });
export const rateEntity = new schema.Entity('rate', {}, { processStrategy });

const fetchRatesCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params });
  const normalized = normalize<
    any,
    { rates: { [key: string]: RateInterface } }
  >(response.data.rates, [ratesEntity]);

  return {
    rates: normalized.entities?.rates || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

export const fetchRates = createAsyncThunk(
  `${PREFIX}_rates/fetchRates`,
  async (params: object = {}) => fetchRatesCollection('/onesky/rates', params)
);

export const fetchRate = createAsyncThunk(
  `${PREFIX}_rates/fetchRate`,
  async (id: string | number) => {
    const response = await callrecorderApi.get(`/onesky/rates/${id}`);
    const normalized = normalize<
      any,
      { rate: { [key: string]: RateInterface } }
    >(response.data.rate, rateEntity);

    return { rate: normalized.entities?.rate || {} };
  }
);
